<template>
  <div>
    <b-tabs pills card>
      <b-tab :title="$t('Terminal')" active @click="terminal">
        <b-row style="margin-right:0px !important">
          <b-col cols="3" md="3" xl="3">
            <div v-for="itemGr in groupedPaymentSystems" :key="itemGr.num" style="margin-bottom:1rem">
              <b-list-group>
                <b-list-group-item id="button-list-group-item" :variant="getVariant(item)" v-for="item in itemGr.data" :key="item.id" @click="selectPaymentSystem(item)">
                  <b style="font-weight: bold;">{{ item.name }}</b>
                  <b-button size="sm" @click.stop="deletePS(item)" id="transparent">
                    <b-img :src='deleteDocumentImage' style="width:16px;height:16px;"/>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          <b-button variant="success" @click="showAddItem" block> {{ $t('Add') }} </b-button>
        </b-col>
        <b-col cols="9" md="9" xl="9">
            <b-row v-if="paymentSystemsData.length > 0" style="margin-right:0px; margin-top:2rem;margin-bottom:2rem;">
              <b-col cols="6" md="6" xl="6" >
                <b-button variant="success" @click="save">{{ $t('Save') }}</b-button>
                <b-button @click="load">{{ $t('Cancel') }}</b-button>
              </b-col>
            </b-row>
            <b-card v-if="getMainFields(paymentSystemsData).length > 0" :title="$t('Main')" style="margin-bottom:1rem;">
              <b-form-group v-for="itemData in getMainFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
            <b-card v-if="getAdditionalFields(paymentSystemsData).length > 0" :title="$t('Additional')" style="margin-bottom:1rem;">
              <b-form-group v-for="itemData in getAdditionalFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
            <b-card v-if="getRecepientFields(paymentSystemsData).length > 0" :title="$t('Receipt')">
              <b-form-group v-for="itemData in getRecepientFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
      <b-tab :title="$t('Acquiring')" @click="acquiring">
        <b-row style="margin-right:0px !important">
          <b-col cols="3" md="3" xl="3">
            <div v-for="itemGr in groupedPaymentSystems" :key="itemGr.group_id" style="margin-bottom:1rem">
              <div class="title"> {{ $t('Group') }}: <b style="font-weight: bold;">{{ getGroupName(itemGr.group_id) }} </b></div>
              <b-list-group>
                <b-list-group-item id="button-list-group-item" :variant="getVariant(item)" v-for="item in itemGr.data" :key="item.id" @click="selectPaymentSystem(item)">
                  <b style="font-weight: bold;">{{ item.name }}</b>
                  <b-button size="sm" @click.stop="deletePS(item)" id="transparent">
                    <b-img :src='deleteDocumentImage' style="width:16px;height:16px;"/>
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
          <b-button variant="success" @click="showAddItem" block> {{ $t('Add') }} </b-button>
        </b-col>
        <b-col cols="9" md="9" xl="9">
            <b-row v-if="paymentSystemsData.length > 0" style="margin-right:0px; margin-top:2rem;margin-bottom:2rem;">
              <b-col cols="6" md="6" xl="6" >
                <b-button variant="success" @click="save">{{ $t('Save') }}</b-button>
                <b-button @click="load">{{ $t('Cancel') }}</b-button>
              </b-col>
            </b-row>
            <b-card v-if="getMainFields(paymentSystemsData).length > 0" :title="$t('Main')" style="margin-bottom:1rem;">
              <b-form-group v-for="itemData in getMainFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
            <b-card v-if="getAdditionalFields(paymentSystemsData).length > 0" :title="$t('Additional')" style="margin-bottom:1rem;">
              <b-form-group v-for="itemData in getAdditionalFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
            <b-card v-if="getRecepientFields(paymentSystemsData).length > 0" :title="$t('Receipt')">
              <b-form-group v-for="itemData in getRecepientFields(paymentSystemsData)" :key="itemData.id" :label="$t(itemData.name)" label-cols="4" label-cols-xl="4" label-cols-md="4">
                <b-form-input v-if="isFieldText(itemData)" type="text" v-model="itemData.value"/>
                <b-form-select v-if="isFieldSelect(itemData)" v-model="itemData.value" :options="getSelectFieldOptions(itemData)"/>
              </b-form-group>
            </b-card>
          </b-col>
        </b-row>
      </b-tab>
    </b-tabs>

    <b-modal ref="modalAddPaymentSystem" hide-footer>
        <b-form-group v-if="isAcquiring" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups"/>
        </b-form-group>
        <b-form-group :label="$t('Payment system')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.template_id" :options="paymetSystemsTemplate"/>
        </b-form-group>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveItem">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalAddPaymentSystem.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
    </b-modal>
  </div>
</template>

<script>
import axiosInstance from '@/utils/api.js'

export default {
  data () {
    return {
      isAcquiring: false,
      isTerminal: true,
      editItem: {
        group_id: 0,
        template_id: 0,
        data: [],
        id: 0
      },
      curItem: null,
      paymentSystems: [],
      paymentSystemsData: [],
      groupedPaymentSystems: [],
      optionsYesNo: [{
        value: 'yes',
        text: this.$t('Yes')
      }, {
        value: 'no',
        text: this.$t('No')
      }],
      optionsOneZero: [{
        value: '1',
        text: this.$t('Yes')
      }, {
        value: '0',
        text: this.$t('No')
      }],
      authorizationTypes: [{
        value: 'Account ID',
        text: this.$t('Account ID')
      }, {
        value: 'External ID',
        text: this.$t('External ID')
      }, {
        value: 'Login',
        text: this.$t('Login')
      }],
      yesNoParams: ['Enabled', 'Test mode(yes,no)', 'Receipt enabled'],
      oneZeroParams: ['Turn on inet after payment(1,0)'],
      paymentMethodsParams: ['Payment method ID'],
      currency: ['Internal currency ID'],
      authorizationType: ['Authorization type'],
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      mainFileds: ['Enabled', 'Test mode(yes,no)', 'Turn on inet after payment(1,0)', 'Payment method ID', 'Internal currency ID']
    }
  },
  methods: {
    getMainFields (fields) {
      return fields.filter(el => {
        return this.mainFileds.some(r => el.name.includes(r))
      })
    },
    getAdditionalFields (fields) {
      return fields.filter(el => {
        return !el.name.includes('Receipt') && !this.mainFileds.some(r => el.name.includes(r))
      })
    },
    getRecepientFields (fields) {
      return fields.filter(el => {
        return el.name.includes('Receipt')
      })
    },
    terminal () {
      this.isAcquiring = false
      this.isTerminal = true
      this.load()
    },
    acquiring () {
      this.isAcquiring = true
      this.isTerminal = false
      this.load()
    },
    showAddItem () {
      this.editItem = {
        group_id: 0,
        data: [],
        template_id: 0,
        id: 0
      }
      this.$refs.modalAddPaymentSystem.show()
    },
    isFieldText (item) {
      return !this.isFieldSelect(item)
    },
    isFieldSelect (item) {
      return this.yesNoParams.includes(item.name) ||
            this.oneZeroParams.includes(item.name) ||
            this.paymentMethodsParams.includes(item.name) ||
            this.authorizationType.includes(item.name) ||
            this.currency.includes(item.name)
    },
    getSelectFieldOptions (item) {
      if (this.yesNoParams.includes(item.name)) return this.optionsYesNo
      if (this.oneZeroParams.includes(item.name)) return this.optionsOneZero
      if (this.paymentMethodsParams.includes(item.name)) return this.paymentMethods
      if (this.currency.includes(item.name)) return this.currencies
      if (this.authorizationType.includes(item.name)) return this.authorizationTypes
      return []
    },
    save () {
      let response = this.$store.dispatch('Settings/UPDATE_PAYMENT_SYSTEMS', this.paymentSystems)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          this.load()
          this.$root.$emit('makeToasts')
        }
      })
    },
    async load () {
      this.groupedPaymentSystems = []
      this.curItem = null
      this.paymentSystemsData = []
      this.paymentSystems = await axiosInstance.get(this.$store.getters.API_SETTINGS_PAYMENT_SYSTEMS).then(response => { return response.data.sort((a, b) => a.name > b.name ? 1 : -1) })
      let groupedPaymentSystems = []
      if (this.isTerminal) {
        let num = 0
        for (let el of this.paymentSystems) {
          for (let elData of el.data) {
            if (elData.name === 'OSMPFLAG' && elData.value === '1') {
              let newEl = {
                group_id: el.group_id,
                data: [],
                num: 0
              }
              newEl.num = ++num
              newEl.data.push(el)
              groupedPaymentSystems.push(newEl)
            }
          }
        }
        this.groupedPaymentSystems = groupedPaymentSystems
      }
      if (this.isAcquiring) {
        for (let el of this.paymentSystems) {
          let isName = true
          for (let elData of el.data) {
            if (elData.name === 'OSMPFLAG' && elData.value === '1') {
              isName = false
            }
          }
          if (isName) {
            let isFound = false
            for (let elGr of groupedPaymentSystems) {
              if (elGr.group_id === el.group_id) {
                elGr.data.push(el)
                isFound = true
                break
              }
            }
            if (!isFound) {
              let newEl = {
                group_id: el.group_id,
                data: []
              }
              newEl.data.push(el)
              groupedPaymentSystems.push(newEl)
            }
          }
          this.groupedPaymentSystems = groupedPaymentSystems
        }
      }
    },
    selectPaymentSystem (item) {
      if (item === this.curItem) {
        this.curItem = null
        this.paymentSystemsData = []
      } else {
        this.curItem = item
        this.paymentSystemsData = this.curItem.data.sort((a, b) => a.name > b.name ? 1 : -1)
        if (this.isTerminal) {
          this.paymentSystemsData = this.paymentSystemsData.filter((value) => {
            return value.name !== 'OSMPFLAG'
          })
        }
      }
    },
    getVariant (item) {
      if (this.curItem) {
        if (item.id === this.curItem.id) {
          return 'info'
        }
      }
      for (let el of item.data) {
        if (el.name === 'Enabled') {
          return el.value === 'yes' ? 'success' : 'danger'
        }
      }
      return 'default'
    },
    getGroupName (groupID) {
      for (let el of this.groups) {
        if (el.value === groupID) {
          return el.text
        }
      }
    },
    async saveItem () {
      if (!this.editItem.template_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select payment system'), 'Error')
        return
      }
      let newPS = {
        group_id: this.editItem.group_id,
        name: '',
        data: []
      }
      for (let el of this.paymetSystemsDataTemplate) {
        if (this.editItem.template_id === el.id) {
          newPS.data = el.data
          newPS.name = el.name
        }
      }
      let response = await this.$store.dispatch('Settings/CREATE_PAYMENT_SYSTEMS', newPS).then(response => { return response })
      if (response.data.error) {
        this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
      } else {
        this.$root.$emit('makeToasts')
        this.$refs.modalAddPaymentSystem.hide()
        this.load()
      }
    },
    deletePS (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "Payment system"?'), this.realDeletePS, item)
    },
    async realDeletePS (item) {
      let response = await this.$store.dispatch('Settings/DELETE_PAYMENT_SYSTEMS', item.id).then(response => { return response })
      if (response.data.error) {
        this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
      } else {
        this.$root.$emit('makeToasts')
        this.load()
      }
    }
  },
  computed: {
    paymentMethods () {
      let res = []
      for (let el of this.$store.getters['ReferenceBooks/PAYMENT_METHODS']) {
        let newEl = {}
        newEl.value = el.id.toString()
        newEl.text = this.$t(el.name)
        res.push(newEl)
      }
      return res
    },
    currencies () {
      let res = []
      for (let el of this.$store.getters['ReferenceBooks/CURRENCIES']) {
        let newEl = {}
        newEl.value = el.currency_id.toString()
        newEl.text = el.currency_brief_name
        res.push(newEl)
      }
      return res
    },
    groups () {
      let res = []
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      res.push({value: 0, text: this.$t('All')})
      return res
    },
    paymetSystemsTemplate () {
      let res = []
      for (let el of this.$store.getters['Settings/PAYMENT_SYSTEMS_TEMPLATE']) {
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        newEl.data = el.data
        res.push(newEl)
      }
      if (this.isTerminal) {
        res = res.filter((item) => {
          for (let el of item.data) {
            if (el.name === 'OSMPFLAG' && el.value === '1') {
              return true
            }
          }
        })
        return res.filter((item) => {
          for (let el of this.groupedPaymentSystems) {
            if (el.data[0].name === item.text) {
              return false
            }
          }
          return true
        })
      }
      if (this.isAcquiring) {
        return res.filter((item) => {
          for (let el of item.data) {
            if (el.name === 'OSMPFLAG' && el.value === '1') {
              return false
            }
          }
          for (let el of this.groupedPaymentSystems) {
            if (el.group_id === this.editItem.group_id) {
              for (let elPS of el.data) {
                if (elPS.name === item.text) {
                  return false
                }
              }
            }
          }
          return true
        })
      }
    },
    paymetSystemsDataTemplate () {
      return this.$store.getters['Settings/PAYMENT_SYSTEMS_TEMPLATE']
    }
  },
  mounted () {
    this.load()
    this.$store.dispatch('ReferenceBooks/GET_PAYMENT_METHODS')
    this.$store.dispatch('ReferenceBooks/GET_CURRENCIES')
    this.$store.dispatch('Users/GET_GROUPS')
    this.$store.dispatch('Settings/GET_PAYMENT_SYSTEMS_TEMPLATE')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/customerPortal/paymentSystems/main.vue